<accredible-button-filter
  [size]="buttonSize"
  [icon]="'chevron-down'"
  [selected]="selectedOptions.length > 0"
  [disabled]="disabled"
  [attr.data-cy]="dataCy"
  [menuWidthEqualsButtonWidth]="menuWidthEqualsButtonWidth"
  (menuToggle)="onMenuToggle($event)">
  <ng-container buttonFilterText>
    {{ buttonText }}
    <span *ngIf="selectedOptions.length > 0" class="current-selection font-s-semibold">{{
      selectedOptions.length
    }}</span>
  </ng-container>

  <accredible-multi-search-filter
    *ngIf="menuOpened"
    [placeholder]="placeholder"
    [options]="options"
    [optionsLabelKey]="optionsLabelKey"
    [optionsImgKey]="optionsImgKey"
    [selectedOptions]="selectedOptions"
    [usingStaticOptions]="usingStaticOptions"
    [useEllipsisOnOptions]="useEllipsisOnOptions"
    [isInMenu]="true"
    [hideSearchInput]="hideSearchInput"
    [maxSelect]="maxSelect"
    (click)="$event.stopPropagation()"
    (optionsChanged)="optionsChanged.emit($event)"
    (searchChanged)="searchChanged.emit($event)">
  </accredible-multi-search-filter>
</accredible-button-filter>
